export default __webpack_public_path__ + "static/media/miss-punch.3a738895.mp3";